<template>
  <div>
    <BackButton link="/partners" text="Back to Service partner profiles" />
    <form @submit.prevent="attemptSendInvites(invites)">
      <DashboardHeader
        heading="Invite partner"
        paragraph="Invite partners to join your directory"
      >
      </DashboardHeader>

      <div class="flex items-center">
        <div
          class="flex justify-between border rounded border-gray-light border-solid h-10 items-center px-4"
          style="max-width: 583px;"
        >
          <p id="getListed" class="text-sm text-gray-gray">
            {{ $store.getters.agenciesDirectoryGetListedUrl }}
          </p>
          <Button
            type="button"
            bType="text"
            bTextColor="primary"
            v-on:button-click="copyToClipboard"
            >Copy Link
          </Button>
        </div>
        <a
          class="pl-3 text-violet"
          target="_blank"
          href="https://www.notion.so/partnerpage/Get-Listed-37f89cafa934449c996683a0130fa3a0"
          >Learn more<LinkIcon
        /></a>
      </div>

      <hr class="mb-lg" />
      <div class="grid grid--rev">
        <div class="grid__cell col5-of-12--large-up"></div>
        <div class="grid__cell col7-of-12--large-up">
          <Invitation
            v-for="(invite, i) in inviteCount"
            :key="i"
            :index="i"
            @invite-change="handleInviteChange"
          />
          <div class="flex justify-end">
            <Button
              type="button"
              v-on:button-click="addInvite"
              bType="secondary"
            >
              Add new invitation
            </Button>
            <Button type="submit" bMargin="left">
              Send invitations
            </Button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import BackButton from '@/components/BackButton';
import DashboardHeader from '@/components/Dashboard/DashboardHeader';
import Invitation from '@/components/Dashboard/Invitation';
import LinkIcon from '@/components/DesignSystem/LinkIcon';
import Button from '@/components/DesignSystem/Button';
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('agencyProfiles/inviteAgencies');

export default {
  name: 'inviteDetailPage',
  components: {
    BackButton,
    DashboardHeader,
    Invitation,
    LinkIcon,
    Button,
  },
  props: {
    backUrl: {
      type: String,
    },
  },
  data() {
    return {
      inviteCount: 1,
      invites: [{}],
    };
  },
  methods: {
    async attemptSendInvites(invites) {
      await this.sendInvites(invites);
    },
    ...mapActions(['sendInvites']),
    addInvite() {
      this.inviteCount++;
    },

    copyToClipboard() {
      navigator.clipboard
        .writeText(this.$store.getters.agenciesDirectoryGetListedUrl)
        .then(() => {
          this.$store
            .dispatch('showUserMessage', {
              success: true,
              title: 'Link copied!',
            })
            .catch(() => {
              this.$store.dispatch('showUserMessage', {
                success: false,
                title: 'Sorry!',
                message: 'Something went wrong copying your Get Listed link.',
              });
            });
        });
    },

    // payload will be invite data from component
    handleInviteChange(payload) {
      this.invites[payload.key] = payload.data;
    },
  },
};
</script>
